import { render } from "solid-js/web";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@vianetz/spectre.css/dist/spectre.min.css";
import "../assets/style/main.scss";
import App from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root mount element");

render(() => <App />, root);
